<template>
  <el-dialog
    class="feedback-modal"
    width="90%"
    :visible.sync="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="true"
  >
    <form class="respone-form">
      <div>
        <el-input v-model="content" type="textarea" placeholder="请输入回应内容" :row="3" resize="none" />
      </div>
      <div class="actions">
        <el-button type="primary" size="small" @click="doSubmit">确定</el-button>
        <el-button type="default" size="small" @click="close(false)">取消</el-button>
      </div>
    </form>
  </el-dialog>
</template>
<script>
import ModalMixin from '@/mixins/modal/modal-mixin'
import { doAnswer } from '../services'
export default {
  name: 'FeedbackModal',
  mixins: [ ModalMixin ],
  data () {
    return {
      feedback: {
        id: undefined
      },
      content: ''
    }
  },
  methods: {
    init (feedback) {
      this.feedback = feedback
      return this.open()
    },
    doSubmit () {
      doAnswer({ id: this.feedback.id, answer: this.content }).then((resp) => {
        this.feedback.answer = this.content
        this.close(true)
      })
    }
  }
}
</script>
<style lang="stylus">
.feedback-modal
  .el-dialog
    max-width 600px
    .el-dialog__header
      display none
    .actions
      margin-top 8px
</style>
